import { Button, Card, FlexBox, Modal, Table, Tooltip } from '@cimpress/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactElement, useState } from 'react';
import { CustomPattern, EventMapping } from '../../clients/dto/VLRATypes';
import { makeFieldLayout } from './util/helpers';
import { TestData } from './util/types';
import GenericHistoryView, { HistoryColumnData } from '../common/GenericHistoryView';
import { ModalAlert } from '../../types/modal-alert';

type TableColumn = {
  Header: string,
  accessor: keyof EventMapping,
}

const eventMappingColumns: TableColumn[] = [
  { Header: 'Input Event', accessor: 'inputEvent' },
  { Header: 'Output Event/Status', accessor: 'outputEventOrStatus' },
  { Header: 'Half-processed Output Event/Status', accessor: 'halfProcessedEventOrStatus' },
];

const historyColumns: HistoryColumnData[] = [
  { key: 'name', displayName: 'Name' },
  { key: 'priority', displayName: 'Priority' },
  { key: 'strategy', displayName: 'Strategy' },
  { key: 'backsideProcessing', displayName: 'Backside Processing' },
  { key: 'filenameRegex', displayName: 'Filename Regex' },
  { key: 'examples', displayName: 'Examples' },
  { key: 'eventMapping', displayName: 'Event Mappings' },
];

interface CustomPatternDisplayProps {
  pattern: CustomPattern,
  onTestSelected: (testData: TestData) => void,
  onEditSelected: (pattern: CustomPattern) => void,
  showAlert: (alert: ModalAlert) => void
}
export function CustomPatternDisplay({onTestSelected, pattern, onEditSelected, showAlert} : CustomPatternDisplayProps): ReactElement {
  const [customPatternToOpenHistory, setCustomPatternToOpenHistory] = useState(null as CustomPattern | null);

  const header = <FlexBox>
    <span>{pattern.name}</span>
    <FlexBox style={{gap: 10}}>
      <Tooltip contents="Pattern History">
        <Button
          variant="anchor"
          size="lg"
          icon={<FontAwesomeIcon icon="history" />}
          onClick={() => {
            setCustomPatternToOpenHistory(pattern);
          }}
        />
      </Tooltip>
      <Tooltip contents="Edit Pattern">
        <Button
          variant="anchor"
          size="lg"
          icon={<FontAwesomeIcon icon="pencil-alt" />}
          onClick={() => {
            onEditSelected(pattern);
          }}
        />
      </Tooltip>
    </FlexBox>
  </FlexBox>;

  return (<>
    <Card className='ms-3 mb-2' header={header} >
      {makeFieldLayout('Priority', <>{pattern.priority}</>)}
      {makeFieldLayout('Strategy', <>{pattern.strategy}</>)}
      {makeFieldLayout('Backside Processing Enabled Expression', <code>{pattern.backsideProcessing?.isEnabledExpression}</code>)}
      {makeFieldLayout('Event Mappings', <Table columns={eventMappingColumns} data={pattern.eventMapping ?? []} />)}
      {makeFieldLayout('Regex', <code>{pattern.filenameRegex}</code>)}
      {makeFieldLayout('Examples', <>{(pattern.examples ?? []).map(example => <p key={example}>{example} <Button variant='link' onClick={() => onTestSelected({filename: example})}>Test <FontAwesomeIcon icon="arrow-alt-circle-down" /></Button></p>)}</>)}
    </Card>
    <Modal
      status="info"
      show={!!customPatternToOpenHistory}
      onRequestHide={() => setCustomPatternToOpenHistory(null)}
      title="Custom Pattern History"
      closeButton={true}
      size={'lg'}
      style={{width: '80%'}}
    >
      {customPatternToOpenHistory && <GenericHistoryView displayName={customPatternToOpenHistory.name} entityId={customPatternToOpenHistory.id} entityType='VLRA-CustomPattern' tenant={customPatternToOpenHistory.tenant} showAlert={showAlert} recordsStartDate={new Date(2026, 8, 8)} columns={historyColumns}/>}
    </Modal>
  </>);
}
